import { useRequiredParams } from '@pba/react-router';
import { MemberLayout, MemberOrganizations, MemberOrganizationsHeader } from 'features/users';
import { useGetPathToEntityDetail } from 'pages/hooks';

const PageMemberOrganizations = () => {
  const { memberId } = useRequiredParams<{ memberId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();

  return (
    <MemberLayout header={(member) => <MemberOrganizationsHeader member={member} />} memberId={memberId}>
      {(member) => (
        <MemberOrganizations
          getPathToOrganizationDetail={(id) => getPathToEntityDetail(id, { entityType: 'organization' })}
          member={member}
        />
      )}
    </MemberLayout>
  );
};

export default PageMemberOrganizations;
